export const isWithinXDays = (timestamp: number, numberOfDays: number): boolean => {
  const currentTimestamp = Date.now();
  const differenceInMilliseconds = currentTimestamp - timestamp;
  const sevenDaysInMilliseconds = numberOfDays * 24 * 60 * 60 * 1000;
  return differenceInMilliseconds < sevenDaysInMilliseconds;
}